import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { DEFAULT_VIEW_IDS, DEFAULT_VIEW_LABELS, VIEW_NAMESPACE } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { getDashboardViewRoute } from 'FormsUI/lib/RouteGenerators';
import { hasContactsRead as hasContactsReadSelector } from 'FormsUI/selectors/Scope';

/**
 * Combination of all view id and label for default views
 */

/**
 * All valid view urls
 */

/**
 * Map of view id and labels to view urls
 */
const DefaultViewIdToUrl = {
  [DEFAULT_VIEW_IDS.ALL_FORMS]: DEFAULT_VIEW_LABELS.ALL_FORMS,
  all_forms: DEFAULT_VIEW_LABELS.ALL_FORMS,
  [DEFAULT_VIEW_IDS.FORMS_WITH_SUBMISSIONS]: DEFAULT_VIEW_LABELS.FORMS_WITH_SUBMISSIONS,
  forms_with_submissions: DEFAULT_VIEW_LABELS.FORMS_WITH_SUBMISSIONS,
  [DEFAULT_VIEW_IDS.PUBLISHED]: DEFAULT_VIEW_LABELS.PUBLISHED,
  published_forms: DEFAULT_VIEW_LABELS.PUBLISHED,
  [DEFAULT_VIEW_IDS.NON_HUBSPOT]: DEFAULT_VIEW_LABELS.NON_HUBSPOT,
  non_hubspot_forms: DEFAULT_VIEW_LABELS.NON_HUBSPOT
};

/**
 * Map of view urls to view ids
 */
const ViewUrlToViewId = {
  [DEFAULT_VIEW_LABELS.ALL_FORMS]: DEFAULT_VIEW_LABELS.ALL_FORMS,
  [DEFAULT_VIEW_LABELS.FORMS_WITH_SUBMISSIONS]: DEFAULT_VIEW_LABELS.FORMS_WITH_SUBMISSIONS,
  [DEFAULT_VIEW_LABELS.PUBLISHED]: DEFAULT_VIEW_LABELS.PUBLISHED,
  [DEFAULT_VIEW_LABELS.NON_HUBSPOT]: DEFAULT_VIEW_LABELS.NON_HUBSPOT
};
const isDefaultViewId = viewId => Object.keys(DefaultViewIdToUrl).includes(viewId);
const isDefaultViewUrl = viewUrl => Object.keys(ViewUrlToViewId).includes(viewUrl);
const viewIdToUrl = viewIdString => isDefaultViewId(viewIdString) ? DefaultViewIdToUrl[viewIdString] : viewIdString;
const urlToViewId = viewIdUrl => viewIdUrl && isDefaultViewUrl(viewIdUrl) ? ViewUrlToViewId[viewIdUrl] : viewIdUrl;
const useFormsFrameworkViews = () => {
  var _window$location$href;
  const history = useHistory();
  const location = useLocation();
  const viewIdParam = urlToViewId((_window$location$href = window.location.href.match(/\/views\/([^?]+)/)) === null || _window$location$href === void 0 ? void 0 : _window$location$href[1]);
  const isViewsMode = location.pathname.includes('/views');
  const hasContactsRead = useSelector(hasContactsReadSelector);
  const handleViewChange = useCallback(viewId => {
    history.push(getDashboardViewRoute(viewIdToUrl(viewId)));
  }, [history]);
  return useMemo(() => ({
    currentViewId: viewIdParam,
    hasViews: hasContactsRead,
    onViewIdChange: handleViewChange,
    namespace: VIEW_NAMESPACE,
    isViewsMode
  }), [viewIdParam, handleViewChange, hasContactsRead, isViewsMode]);
};
export default useFormsFrameworkViews;